module.exports = __webpack_public_path__ + "img/title.4943c677.png";